import { gql } from "@apollo/client";

export const GET_LANGUAGES_LIST_GQL = gql`
  query {
    langugaes {
      messageDescription
      responseData {
        description
        id
        language_code
      }
      successTypeCode
    }
  }
`;

export const SET_AGENT_LANGUAGE_GQL = gql`
  mutation ($request: String!) {
    updateUserLanguage(language: $request) {
      messageDescription
      responseData
      successTypeCode
    }
  }
`;

export const GET_IPINFO_QUERY = gql`
 query {
  clientIpAddress {
    client_ip_address
    message
  }
}
`;
